import { createSvgIcon } from '@material-ui/core';

export const DragIcon = createSvgIcon(
  <svg viewBox="0 0 8 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_4360_395)">
      <rect
        x="1.5"
        y="1"
        width="5"
        height="30"
        rx="1.5"
        fill="white"
        shapeRendering="crispEdges"
      />
      <rect
        x="1"
        y="0.5"
        width="6"
        height="31"
        rx="2"
        stroke="#E0E0E0"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4360_395"
        x="-2"
        y="-2"
        width="12"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.572549 0 0 0 0 0.572549 0 0 0 0 0.572549 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4360_395"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4360_395"
          result="shape"
        />
      </filter>
    </defs>
  </svg>,
  'DragIcon',
);
